import React from 'react';
import { Box } from '@common-fe/common-fe';

import { PlanCodeField } from '@/components/controls/PlanCodeField';
import { Plan } from '@/modules/plan/plan.types.ts';

import { PlanField, useEditablePlan, usePlanFieldError, usePlansActions } from './hooks/usePlanCodeActions';

interface PlanCodeProps {
  defaultPlan?: Plan;
  showError?: boolean;
  isViewMode?: boolean;
  showEditAction?: boolean;
}

const PlanCode: React.FC<PlanCodeProps> = ({ defaultPlan, showError, isViewMode, showEditAction }) => {
  const { updateEntityDebounced, resetEntity } = usePlansActions();
  const editablePlan = useEditablePlan(defaultPlan?.id);
  const errorText = usePlanFieldError(defaultPlan?.id, PlanField.PlanCode);

  return (
    <Box margin={{ top: 's' }}>
      <PlanCodeField
        planCode={editablePlan?.planCode}
        defaultPlanCode={defaultPlan?.planCode}
        onChange={(value) => {
          if (defaultPlan?.id) updateEntityDebounced(defaultPlan.id, PlanField.PlanCode, value);
        }}
        onReset={() => defaultPlan?.id && resetEntity(defaultPlan.id, PlanField.PlanCode)}
        showEditAction={showEditAction}
        isViewMode={isViewMode}
        showError={showError}
        errorText={errorText}
        testId="plan-code"
      />
    </Box>
  );
};

export default PlanCode;
